import { render, staticRenderFns } from "./UberPersonalizations.vue?vue&type=template&id=3c31b0c2"
import script from "./UberPersonalizations.vue?vue&type=script&lang=js"
export * from "./UberPersonalizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports